<template>
	<div class="exploreCon" :class="{exploreCons:typeName=='explore'}" @click="close()">
		<div class="exploreContainer">
			<div class="topHead">
				<div class="screenbox">
					<div class="tagbox">
						{{job_type?(job_type=='0'?'社招':job_type=='1'?'实习':'兼职'):'求职类型'}} 
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':job_type===''}" @click="restScreen('job_type')">
									不限 <i v-if="job_type===''" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':job_type==='0'}" @click="pickScreen('0','job_type')">
									社招 <i v-if="job_type==='0'" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':job_type==='1'}" @click="pickScreen('1','job_type')">
									实习 <i v-if="job_type==='1'" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':job_type==='2'}" @click="pickScreen('2','job_type')">
									兼职 <i v-if="job_type==='2'" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 结算方式 -->
					<div class="tagbox">
						{{salary_type?salary_type:'结算方式'}} 
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':salary_type==''}" @click="restScreen('salary_type')">
									不限
									<i v-if="salary_type==''" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':salary_type==item}"
									v-for="(item,index) in salaryTypeList" 
									:key="index" 
									@click="pickScreen(item,'salary_type')">
									{{item}}
									<i v-if="salary_type==item" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 工作经验 -->
					<div class="tagbox">
						{{work_year?work_year:'工作经验'}} 
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':work_year==''}" @click="restScreen('work_year')">
									不限
									<i v-if="work_year==''" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':work_year==item}"
									v-for="(item,index) in expList" 
									:key="index" 
									@click="pickScreen(item,'work_year')">
									{{item}}
									<i v-if="work_year==item" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 期望薪资 -->
					<div class="tagbox">
						{{salary_min||salary_max?calcSelect('salary'):'期望薪资'}}
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div 
									class="list" 
									:class="{'select':salary_min==item.min&&salary_max==item.max}"
									v-for="(item,index) in salaryList" 
									:key="index" 
									@click="chooseSalary(item)">
									{{item.label}}
									<i v-if="salary_min==item.min&&salary_max==item.max" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 年龄限制 -->
					<div class="tagbox">
						{{min_age||max_age?calcSelect('age'):'年龄限制'}}
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div 
									class="list" 
									:class="{'select':min_age==item.min&&max_age==item.max}"
									v-for="(item,index) in ageList" 
									:key="index" 
									@click="chooseAge(item)">
									{{item.label}}
									<i v-if="min_age==item.min&&max_age==item.max" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 学历要求 -->
					<div class="tagbox">
						学历要求<span v-if="qualifications.length>0">（{{qualifications.length}}）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':qualifications.length==0}" @click="restScreen('qualifications','array')">
									不限
									<i v-if="qualifications.length==0" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':qualifications.includes(item)}"
									v-for="(item,index) in eduList" 
									:key="index" 
									@click="chooseScreen(item,'qualifications')">
									{{item}}
									<i v-if="qualifications.includes(item)" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
				
					<div class="restbtn"><span @click="restSearch()">清空所有筛选项</span></div>
				</div>
			</div>
			
			<div v-loading="loading" style="min-height: 500px;">
				<div class="nodata" v-if="list.length==0" style="height: 500px;background: #FFF;">
					<no-Data text="没有招聘中的职位或没有匹配到对应的人才"></no-Data>
				</div>
				<curriculumVita :list='list' :type='1' @chatConfirm="chatConfirm($event)"></curriculumVita>
			</div>
			
			<div v-if="total>limit" class="page">
				<el-pagination background :page-size="limit" :current-page="page" :page-sizes="[5, 10, 20]" layout="sizes,prev, pager, next" :total="total"
					@current-change='changePage' @size-change="changeLimit">
				</el-pagination>
			</div>
			
		</div>
		
		<el-dialog
			title="发起沟通"
			:visible.sync="chatShow"
			width="400px">
			<div>
				<el-form label-width="70px">
					<el-form-item label="沟通职位">
						<el-select style="width: 100%;" v-model="position_id"  placeholder="请选择沟通的职位">
						    <el-option v-for="item in positionList" :key="item.id" :label="item.position_name" :value="item.id" />
						</el-select>
					</el-form-item>
				</el-form>
				<div style="text-align: center;margin-top: 28px;">
					<el-button @click="chatShow = false">取 消</el-button>
					<el-button type="primary" @click="toChat()">确定</el-button>
				</div>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	import curriculumVita from '@/components/curriculumVita.vue'
	import { eduList, expList ,salaryTypeList } from '@/unit/disposition.js';
	export default {
		name: 'explore',
		components:{
			curriculumVita
		},
		data() {
			return {
				typeName:'fierce',//fierce是牛人，explore是探索
				popupStatus:false,
				selectIndex:'',
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit:5,
				salary_type:'',
				work_year:'',
				job_type:'',
				salary_min:'',
				salary_max:'',
				min_age:'',
				max_age:'',
				qualifications:[],
				salaryList:[
					{min:0,max:0,label:'不限'},
					{min:0,max:3000,label:'3k以下'},
					{min:3000,max:5000,label:'3-5k'},
					{min:5000,max:10000,label:'5-10k'},
					{min:10000,max:20000,label:'10-20k'},
					{min:20000,max:50000,label:'20-50k'},
					{min:50000,max:0,label:'50k以上'},
				],
				ageList:[
					{min:0,max:0,label:'不限'},
					{min:0,max:20,label:'20岁以下'},
					{min:20,max:30,label:'20-30岁'},
					{min:30,max:40,label:'30-40岁'},
					{min:40,max:50,label:'40-50岁'},
					{min:50,max:0,label:'50岁以上'},
				],
				eduList:eduList,
				expList:expList,
				salaryTypeList:salaryTypeList,
				user_im_account:'',
				positionList:[],
				position_id:'',
				chatShow:false,
			}
		},
		created() {
			this.typeName=this.$route.name
			this.getList()
			this.getMyPosition()
		},
		watch:{
			$route(){
				this.typeName=this.$route.name
				this.page=1
				this.getList()
			}
		},
		methods: {
			async toChat(){
				if(!this.position_id) return this.$eltips('请选择沟通的职位','warning')
				await this.$store.dispatch('checkoutConversation', {
					conversationID:`C2C${this.user_im_account}`,
					position_id:this.position_id
				})
				this.$router.push({ name: 'communication'});
			},
			getMyPosition(){
				let data = {
					status:0,
					no_page:1
				}
				this.$axios.get('/api/client/ES/getPositionList',{params:data}).then(res=>{
					if(res.code==200){
						this.positionList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			chatConfirm(e){
				this.user_im_account = e.user_im_account
				this.position_id = e.position.id
				this.chatShow = true
			},
			calcSelect(type){
				if(type=='age'){
					for(let i = 0;i<this.ageList.length;i++){
						const item = this.ageList[i]
						if(item.min==this.min_age&&item.max==this.max_age){
							return item.label
						}
					}
				}else{
					for(let i = 0;i<this.salaryList.length;i++){
						const item = this.salaryList[i]
						if(item.min==this.salary_min&&item.max==this.salary_max){
							return item.label
						}
					}
				}
			},
			chooseAge(item){
				this.min_age = item.min
				this.max_age = item.max
				this.search()
			},
			chooseSalary(item){
				this.salary_min = item.min
				this.salary_max = item.max
				this.search()
			},
			chooseScreen(val,params){
				if(this[params].includes(val)){
					const index = this[params].findIndex(e=>e==val)
					this[params].splice(index,1)
				}else{
					this[params].push(val)
				}
				this.search()
			},
			restSearch(){
				this.salary_type = ''
				this.work_year = ''
				this.job_type = ''
				this.salary_min = ''
				this.salary_max = ''
				this.min_age = ''
				this.max_age = ''
				this.qualifications = []
				this.search()
			},
			pickScreen(val,params){
				this[params] = val
				this.search()
			},
			restScreen(params,arr){
				if(arr){
					this[params] = []
				}else{
					this[params] = ''
				}
				this.search()
			},
			search(){
				this.page=1
				this.getList()
			},
			changePo(id){
				this.selectIndex=id
				this.popupStatus=false
				this.page=1
				this.getList()
			},
			close(){
				this.popupStatus=false
			},
			getList(){
				this.loading = true
				let data={
					page: this.page,
					limit: this.limit,
					salary_type:this.salary_type,
					work_year:this.work_year,
					job_type:this.job_type,
					salary_min:this.salary_min,
					salary_max:this.salary_max,
					min_age:this.min_age,
					max_age:this.max_age,
					qualifications:this.qualifications.join(',')
				}
				
				this.$axios.get('/api/client/ES/talentPool', {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changeLimit(e){
				this.limit = e
				this.changePage(1)
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.exploreCons{
		padding: 48px 0;
	}
	.exploreCon {
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.page {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 48px 0 0;
		}

		.exploreContainer {
			position: relative;
			z-index: 3;
			width: 1200px;
			margin: 0 auto;
			.search{
				background-color: #51A190;
				width: 1200px;
				height: 62px;
				border-radius: 12px;
				margin: 0 auto 24px;
				display: flex;
				align-items: center;
				position: relative;
				z-index: 3;
				.bor{
					border: 2px solid  #51A190;
				}
				.seleft {
					width: 1066px;
					display: flex;
					align-items: center;
					background-color: #fff;
					border-radius: 12px;
					height: 100%;
					padding: 0 24px;
					box-sizing: border-box;
					font-size: 18px;
						
					.type {
						display: flex;
						align-items: center;
						color: #151515;
						margin-right: 36px;
						cursor: pointer;
						font-weight: bold;
						.icon {
							margin-left: 18px;
							width: 12px;
							height: 12px;
						}
					}
						
					.input {
						font-size: 18px;
						flex: 1;
					}
					
				}
			
			    .button {
			    	flex: 1;
			    	text-align: center;
			    	font-size: 22px;
			    	color: #fff;
			    	cursor: pointer;
			    }
				
				::-webkit-scrollbar {
					width: 6px;
					/*  设置纵轴（y轴）轴滚动条 */
				}
				
				/* 滚动条滑块（里面小方块） */
				::-webkit-scrollbar-thumb {
					border-radius: 10px;
					background: rgba(0, 0, 0, 0.2);
				}
				
				/* 滚动条轨道 */
				::-webkit-scrollbar-track {
					background: rgba(0,0,0, 0.1);
					border-radius: 10px;
					margin: 10px 0;
				}
				
				.popup{
					position: absolute;
					padding: 0 38px;
					border: 1px solid #51A190;
					border-radius: 16px;
					background-color: #FFF;
					left: 0;
					top: 62px;
					z-index: 3;
					height: 451px;
					overflow: auto;
					min-width: 400px;
					.popupLi{
						padding: 20px;
						border-bottom: 1px solid #F0F0F0;
						font-size: 16px;
						color: #151515;
						cursor: pointer;
						&:last-child{
							border-bottom: none;
						}
						.title{
							font-size: 16px;
						}
						.cor{
							color: #5E5E5E;
							font-size: 14px;
							margin-top: 12px;
						}
					}
				}
			}
			
			.recommended{
				display: flex;
				align-items: flex-start;
				color: #151515;
				font-size: 13px;
				margin-bottom: 24px;
				.recommendedUl{
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					margin-left: 10px;
					.recommendedli{
						margin-right: 24px;
					}
				}
			}
		}
	}

	.topHead{
		width: 1200px;
		margin: 0 auto;
		background: #FFF;
		border-radius: 8px;
		margin-bottom: 18px;
		padding: 18px 26px;
		box-sizing: border-box;
		.screenbox{
			.tagbox{
				display: inline-block;
				cursor: pointer;
				padding: 8px 30px 8px 12px;
				background: #f3f3f3;
				font-size: 14px;
				line-height: 1;
				position: relative;
				margin-right: 18px;
				&::after{
					content: '';
					width: 0;
					height: 0;
					position: absolute;
					right: 12px;
					top: 50%;
					margin-top: -2px;
					border-top: 5px solid #999;
					border-right: 5px solid transparent;
					border-left: 5px solid transparent;
				}
				&:hover{
					color: #51A190;
					&::after{
						border-top: none;
						border-left: 5px solid transparent;
						border-right: 5px solid transparent;
						border-bottom: 5px solid #51A190;
					}
					.screenlist{
						display: block;
					}
				}
				.relativebox{
					position: relative;
				}
				.screenlist{
					display: none;
					overflow-y: auto;
					overflow-x: visible;
					position: absolute;
					z-index: 9;
					left: -12px;
					top: 8px;
					background: #FFF;
					color: #131313;
					padding: 8px;
					width: 226px;
					height: 320px;
					box-sizing: border-box;
					box-shadow: 2px 2px 1px 0px rgba(0, 0, 0, 0.1);
					.list{
						padding: 14px 24px 14px 12px;
						overflow-y: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						-webkit-touch-callout: none;
						-webkit-user-select: none;
						-moz-user-select: none; 
						-ms-user-select: none;
						user-select: none;  
						&:hover{
							color: #51A190;
							background: #F8F8F8;
						}
					}
					.select{
						color: #51A190 !important;
						position: relative;
						.icon{
							font-size: 16px;
							position: absolute;
							top: 50%;
							right: 0;
							margin-top: -8px;
						}
					}
				}
				.listChild{
					width: 600px;
					height: 322px;
					padding: 12px;
					background: #FFFFFF;
					position: absolute;
					top: 8px;
					left: 214px;
					z-index: 10;
					border-radius: 8px;
					box-sizing: border-box;
					border: 1px solid #e3e3e3;
					.chiildTitle{
						line-height: 1;
						padding-bottom: 12px;
						font-size: 16px;
						box-sizing: border-box;
						border-bottom: 1px solid #e3e3e3;
						color: #151515;
					}
					.childContent{
						height: 228px;
						overflow-y: auto;
						.text{
							display: inline-block;
							color: #151515;
							width: 132px;
							margin-right: 14px;
							margin-top: 18px;
							overflow: hidden;
							text-overflow: ellipsis;
							vertical-align: top;
							-webkit-touch-callout: none;
							-webkit-user-select: none;
							-moz-user-select: none; 
							-ms-user-select: none;
							user-select: none;  
							&:nth-child(4n){
								margin-right: 0;
							}
							span{
								&:hover{
									color: #51A190;
								}
							}
						}
						.select{
							color: #51A190;
							font-weight: bold;
						}
					}
				}
			}
			.restbtn{
				float: right;
				line-height: 1;
				font-size: 14px;
				padding: 8px 0;
				color: #999;
				span{
					cursor: pointer;
				}
			}
		}
	}
</style>